<div class="d-flex">
  @if (title$ | async; as title) {
  <div class="d-flex flex-column align-items-center justify-content-center">
    @if(type !== 'bc'){
    <h1
      class="page-heading d-flex text-gray-900 fw-bold fs-2qx my-0 flex-column justify-content-center"
    >
      {{ title }}
    </h1>

    } @if(type !== 'title'){ @if (bc$ | async; as _bc) { @if (_bc.length > 0) {
    <!--begin::Breadcrumb-->
    <ul
      class="breadcrumb breadcrumb-separatorless fw-semibold fs-3 fs-lg-7 my-0"
    >
      @for (bc of _bc; track bc) {
      <li
        class="breadcrumb-item"
        [ngClass]="!bc.isSeparator && bc.isActive ? 'text-gray-900' : ''"
        [ngClass]="!bc.isSeparator && !bc.isActive ? 'text-muted' : ''"
        [ngClass]="bc.isSeparator ? 'px-1' : ''"
      >
        @if (!bc.isSeparator) {
        <a
          class="d-flex flex-row align-items-center justify-content-center text-muted text-hover-primary bg-hover-light-primary px-3 py-2 rounded"
          [routerLink]="bc.path"
        >
          @if($index=== 0){
          <app-keenicon
            name="arrow-left"
            class="fs-2x fs-lg-4 me-2 mt-1"
          ></app-keenicon>

          }

          {{ bc.title }}
        </a>
        } @if (bc.isSeparator) {
        <span class="bullet bg-gray-200 w-5px h-2px"></span>
        }
      </li>
      }
      <li class="breadcrumb-item text-gray-900">{{ title }}</li>
    </ul>
    <!--end::Breadcrumb-->
    } } }
  </div>
  }
</div>
